import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-wallet-profile-skeleton',
  templateUrl: 'rmt-wallet-profile-skeleton.html'
})
export class RmtWalletProfileSkeletonComponent {
  @Input() lines: Number;
  list: any[] = [];
  
  ngOnInit() {
    this.list = new Array(this.lines);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-wallet-profile-skeleton/rmt-wallet-profile-skeleton.ts